// src/layout/Topbar.jsx
// 画面上部のヘッダー。ページタイトル / ロールバッジ / ユーザーメニュー / ログアウト / 通知ベル。

import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ROLE_LABEL, ROLE_COLOR } from '../config/roles';
import { getPageLabel } from '../config/menu';
import Icon from '../components/Icon';

export default function Topbar({ user, onLogout, onMenuClick = () => {} }) {
  const location = useLocation();
  const title    = getPageLabel(location.pathname, user);
  const initial  = (user.name || user.student_id || '?').charAt(0).toUpperCase();

  // 開発者モード（開発者の印がある人だけ）【2026-09-29】
  //   オン: ほかの開発者のアカウント・出席・授業も表示する（開発者専用の機能も使える）
  //   オフ: 同じ役割の普通の人とまったく同じ画面
  const [devBusy, setDevBusy] = useState(false);
  const devOn = !!(user.isDeveloper && user.developerMode);
  const toggleDevMode = async () => {
    if (devBusy) return;
    setDevBusy(true);
    try {
      const res = await fetch('/api/user/developer-mode', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') },
        body: JSON.stringify({ enabled: !devOn }),
      });
      const data = await res.json().catch(() => ({}));
      if (data.success) {
        // 表示中のデータを見え方に合わせて取り直すため、画面ごと読み込み直す
        window.location.reload();
        return;
      }
      alert(data.message || '開発者モードを切り替えられませんでした');
    } catch (e) {
      alert('ネットワークエラーで開発者モードを切り替えられませんでした');
    }
    setDevBusy(false);
  };

  return (
    <>
    <header className="topbar">
      {/* スマホ用メニューボタン（デスクトップではCSSで非表示）【2026-07-21】 */}
      <button className="mobile-menu-btn" aria-label="メニューを開く" onClick={onMenuClick}><Icon name="menu" size={22} /></button>
      <h1 className="topbar-title">{title}</h1>
      <div className="topbar-right">
        <span
          className="topbar-role"
          style={{ background: ROLE_COLOR[user.role] + '22', color: ROLE_COLOR[user.role] }}
        >
          {ROLE_LABEL[user.role]}
        </span>
        {user.isDeveloper && (
          <button
            type="button"
            className={'topbar-devmode' + (devOn ? ' on' : '')}
            onClick={toggleDevMode}
            disabled={devBusy}
            title={devOn ? '開発者モード：オン（開発者のデータも表示中）。押すとオフ' : '開発者モード：オフ（普通の画面）。押すとオン'}
          >
            開発 {devOn ? 'ON' : 'OFF'}
          </button>
        )}
        <Link to="/profile" className="topbar-user" title="アカウント設定を開く">
          <div className="topbar-avatar">{initial}</div>
          <div className="topbar-userinfo">
            <div className="topbar-username">{user.name || user.student_id}</div>
            <div className="topbar-userid">{user.student_id}</div>
          </div>
        </Link>
        <button className="topbar-logout" onClick={onLogout}>ログアウト</button>
        <NavLink
          to="/notifications"
          className={({ isActive }) => 'topbar-icon-btn' + (isActive ? ' active' : '')}
          title="通知を開く"
        >
          <Icon name="bell" size={19} />
        </NavLink>
      </div>
    </header>
    {devOn && (
      <div className="topbar-devbanner" role="status">
        開発者モード：開発者のアカウント・出席・授業もまとめて表示しています（普通の人の画面には出ません）
      </div>
    )}
    </>
  );
}
